const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

type Config = {
  onSuccess?: (registration: ServiceWorkerRegistration) => void;
  onUpdate?: (registration: ServiceWorkerRegistration) => void;
};

export function register(config?: Config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);

        navigator.serviceWorker.ready.then(() => {
          console.info('Service worker is ready');
        });
      } else {
        registerValidSW(swUrl, config);
      }
    });
  }
}

export function registerValidSW(swUrl: string, config?: Config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => handleSWRegistration(registration, config))
}

export function handleSWRegistration(registration: ServiceWorkerRegistration, config?: Config) {
  if (!navigator.serviceWorker.controller) {
    window.location.reload();
  }

  if (registration.active) {
    initMessagePort(registration);
  }

  window.addEventListener('online', () => handleRegistrationOnlineStatus(registration));
  window.addEventListener('offline', () => handleRegistrationOfflineStatus(registration));

  registration.addEventListener('updatefound', () => handleRegistrationUpdateFound(registration));
    
  document.addEventListener('visibilitychange', () => handleRegistrationVisibilityChange(registration));
    
  registration.onupdatefound = () => handleSWRegistrationUpdateFound(registration, config);
}

export function handleSWRegistrationUpdateFound(registration: ServiceWorkerRegistration, config?: Config) {
  const installingWorker = registration.installing;
  if (installingWorker === null) {
    return;
  }
  installingWorker.onstatechange = () => handleOnStateChange(registration, installingWorker, config);
}

export function initMessagePort(registration: ServiceWorkerRegistration) {
  const messageChannel = new MessageChannel();
  messageChannel.port1.onmessage = (event) => {
    if (event.data.type === 'PORT_INITIALIZED') {
    } else if (event.data.type === 'SYNC_SUCCESS') {
      window.dispatchEvent(new CustomEvent('SYNC_SUCCESS', { detail: event.data }));
    } else if (event.data.type === 'SYNC_COMPLETE') {
      window.dispatchEvent(new CustomEvent('SYNC_COMPLETE', { detail: event.data }));
    } else if (event.data.type === 'SYNC_ERROR') {
      window.dispatchEvent(new CustomEvent('SYNC_ERROR', { detail: event.data }));
    } else if (event.data.type === 'MANUAL_SYNC') {
      window.dispatchEvent(new CustomEvent('MANUAL_SYNC', { detail: event.data }));
    }
  };

  if (registration.active) {
    registration.active.postMessage({ type: 'INIT_PORT' }, [messageChannel.port2]);
  } else {
    console.warn('No active service worker found to initialize port');
  }
}

export function handleRegistrationUpdateFound(registration: ServiceWorkerRegistration) {
    const installingWorker = registration.installing;
    installingWorker &&  handleRegistration(installingWorker, registration);
} 

export function handleRegistration(installingWorker: ServiceWorker, registration: ServiceWorkerRegistration) {
  installingWorker.addEventListener('statechange', () => 
    installingWorker.state === 'activated' && initMessagePort(registration)
  );
}

export function handleRegistrationVisibilityChange(registration: ServiceWorkerRegistration) {
  document.visibilityState === 'visible' && registration.active && initMessagePort(registration);
}

export function handleRegistrationOnlineStatus(registration: ServiceWorkerRegistration) {
  registration.active && registration.active.postMessage({ type: 'ONLINE_STATUS', isOnline: true });
}

export function handleRegistrationOfflineStatus(registration: ServiceWorkerRegistration) {
  registration.active && registration.active.postMessage({ type: 'ONLINE_STATUS', isOnline: false });
}

export function handleOnStateChange(registration: ServiceWorkerRegistration, installingWorker: ServiceWorker, config?: Config) {
    if (installingWorker.state === 'installed') {
      if (navigator.serviceWorker.controller && config && config.onUpdate) {
          config.onUpdate(registration);
      } else if (config && config.onSuccess) {
          config.onSuccess(registration);
      }
  };
}

export function checkValidServiceWorker(swUrl: string, config?: Config) {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => handleValidSW(response, swUrl, config))
    .catch(() => {
      console.info('No internet connection found. App is running in offline mode.');
    });
}

export function handleValidSW(response: Response, swUrl: string, config?: Config) {
  const contentType = response.headers.get('content-type');
  if (
    response.status === 404 ||
    (contentType != null && contentType.indexOf('javascript') === -1)
  ) {
    navigator.serviceWorker.ready.then((registration) => handleUnregisterSW(registration));
  } else {
    registerValidSW(swUrl, config);
  }
}

export function handleUnregisterSW(registration: ServiceWorkerRegistration) {
  if (typeof registration.unregister === 'function') {
    registration.unregister().then(() => {
      window.location.reload();
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}